const isAuthenticated = (): boolean => {
  if (sessionStorage.getItem("@LockytEnterprise:token")) {
    return true;
  } else {
    return false;
  }
};

export default isAuthenticated;
